import { render, staticRenderFns } from "./ExamEdit.vue?vue&type=template&id=d88b1b04"
import script from "@/controllers/custom/exam/exam-edit.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/exam/exam-edit.js?vue&type=script&lang=js&external"
import style0 from "./ExamEdit.vue?vue&type=style&index=0&id=d88b1b04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports